export const getTemplatePathLabel = item => {
  if (Array.isArray(item?.path) && item.path.length > 0) {
    return item.path.filter(Boolean).join(' / ');
  }
  return 'Sans dossier';
};

export const sortByTemplatePathAndLabel = (a, b) => {
  const pathCompare = getTemplatePathLabel(a).localeCompare(
    getTemplatePathLabel(b),
  );
  if (pathCompare !== 0) return pathCompare;
  return (a?.label || '').localeCompare(b?.label || '');
};
